"use client";

import { useState } from "react";
import { dynamicWithRetry } from "@/lib/chunks/dynamicWithRetry";

const ContactSheet = dynamicWithRetry(
  () => import("./ContactSheet").then((m) => m.ContactSheet),
  { surface: "contact" },
);

type ContactLinkProps = {
  className?: string;
  children?: string;
};

export function ContactLink({ className, children = "Contact" }: ContactLinkProps) {
  const [open, setOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setOpen(true);
          setHasOpened(true);
        }}
        className={className}
      >
        {children}
      </button>
      {hasOpened && <ContactSheet open={open} onOpenChange={setOpen} />}
    </>
  );
}
